import { APIActionTypes } from "./api.types";

export const setIsDownloading = (isDownloading) => ({
  type: APIActionTypes.SET_IS_Downloading,
  payload: isDownloading,
});

export const setSignalRconnection = (connection) => ({
  type: APIActionTypes.SET_SINGNALR_CONNECTION,
  payload: connection,
});

export const setCalculatorContext = (context) => ({
  type: APIActionTypes.SET_CALCULATOR_CONTEXT,
  payload: context,
});
